module.exports = __webpack_public_path__ + "media/images/icons/flags/US-52559577987d897f0d56792c54019d5f.svg";